import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { resolveApiUrl } from "../utils/apiBase";

const useHttpHook = () => {
  const [loading, setloading] = useState(false);
  const [error, setError] = useState(false);
  const [successmessage, setsuccessmessage] = useState(false);
  const user = useSelector((state) => state.user);
  const guard = useSelector((state) => state.guard);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(false);
      }, 100);
    }
  }, [error]);

  const sendRequest = useCallback(
    async (url, configData, Authenticated = true) => {
      setloading(true);
      let config = {};
      config.method =
        configData && configData.hasOwnProperty("method")
          ? configData.method
          : "GET";
      const rawUrl =
        configData && configData.hasOwnProperty("url") ? configData.url : url;
      config.url = resolveApiUrl(rawUrl);
      let requestData;
      if (
        configData &&
        configData.hasOwnProperty("data") &&
        configData.hasOwnProperty("imgFieldArr")
      ) {
        requestData = getFormData(configData.data, configData.imgFieldArr);
      } else if (configData && configData.hasOwnProperty("data")) {
        requestData = configData.data;
      }

      const isFormData =
        typeof FormData !== "undefined" && requestData instanceof FormData;

      config.headers = {};
      if (!isFormData) {
        config.headers["content-type"] =
          configData && configData.hasOwnProperty("contentType")
            ? configData.contentType
            : "application/json";
      }

      // Same access model as event login: authenticated calls auto-attach
      // the active session token. Explicit guardToken still wins when set.
      const sessionToken =
        configData?.guardToken ||
        (Authenticated && user.token) ||
        (Authenticated && !user.token && guard.token) ||
        null;
      if (sessionToken) {
        config.headers.Authorization = `Bearer ${sessionToken}`;
      }
      if (typeof requestData !== "undefined") {
        config.data = requestData;
      }

      try {
        var respnseData = await axios.request(config);
        setsuccessmessage(respnseData.data.message);
        setloading(false);
        return respnseData.data;
      } catch (e) {
        setloading(false);
        const errorMessage =
          e?.response?.data?.message ||
          e?.message ||
          "Something went wrong. Please try again.";
        setError(errorMessage);
        return (
          e?.response?.data || {
            status: 0,
            message: errorMessage,
          }
        );
      }
    },
    [user.token, guard.token]
  );

  const getFormData = (o, ImageField = []) => {
    const formData = new FormData();
    for (const [key, value] of Object.entries(o)) {
      if (ImageField.includes(key)) {
        const files = Array.isArray(value) ? value : value ? [value] : [];
        files.forEach((file) => {
          if (typeof File !== "undefined" && file instanceof File) {
            formData.append(key, file, file.name);
          } else if (file instanceof Blob) {
            formData.append(key, file);
          }
        });
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    }

    return formData;
  };
  return [loading, sendRequest, error, successmessage];
};

export default useHttpHook;
